<div class="tide-container">
    <div class="frame-2171">
        <div class="frame-660">
            <span class="text1">High</span>
            <span class="text2">{{FirstTideHighTime ? (getLocalDateTime(FirstTideHighTime) | date:'hh:mm a' | lowercase) : ""}}</span>
            <span class="text2">{{getTideHeight(FirstTideHighHeight)}}</span>
        </div>
        <div class="frame-660">
            <span class="text1">Low</span>
            <span class="text2">{{FirstTideLowTime ? (getLocalDateTime(FirstTideLowTime) | date:'hh:mm a'  | lowercase) : ""}}</span>
            <span class="text2">{{getTideHeight(FirstTideLowHeight)}}</span>
        </div>
    </div>

    <div class="frame-2171">
        <div class="frame-660">
            <span class="text1">High</span>
            <span class="text2">{{SecondTideHighTime ? (getLocalDateTime(SecondTideHighTime) | date:'hh:mm a' | lowercase) : ""}}</span>
            <span class="text2">{{getTideHeight(SecondTideHighHeight)}}</span>
        </div>
        <div class="frame-660">
            <span class="text1">Low</span>
            <span class="text2">{{SecondTideLowTime ? (getLocalDateTime(SecondTideLowTime) | date:'hh:mm a' | lowercase) : ""}}</span>
            <span class="text2">{{getTideHeight(SecondTideLowHeight)}}</span>
        </div>
    </div>
</div>
